import { useOpeningOrderIncentives } from "@faire/retailer-visitor-shared/stores/domain/useOpeningOrderIncentives";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import {
  chunkTransformations,
  StrictLocalMsg,
} from "@faire/web--source/ui/lib/localization";
import { trackPricingOpeningOrderIncentivesClickOfferBannerRedirectCtaClick } from "@faire/web-api--source/events/pricing/click/openingOrderIncentivesClickOfferBannerRedirectCta";
import isUndefined from "lodash/isUndefined";
import { observer } from "mobx-react";
import React, { type JSX } from "react";

const OpeningOrderIncentivesBannerBase: React.FC = () => {
  const { openingOrderIncentivesProps, trackOOIBannerViewEvent } =
    useOpeningOrderIncentives();

  React.useEffect(() => {
    trackOOIBannerViewEvent();
  }, [trackOOIBannerViewEvent]);

  if (isUndefined(openingOrderIncentivesProps)) {
    return null;
  }

  const { endDate, discountPercentage } = openingOrderIncentivesProps;

  if (endDate === undefined || discountPercentage === undefined) {
    return null;
  }

  return (
    <Typography data-test-id="opening-order-incentives-banner" align="center">
      <StrictLocalMsg
        defaultMessage="<MediumFormatting>Enjoy {discountPercentageNumber}% off!</MediumFormatting> Try something new and save. Expires {endDate}. <LinkFormatting>View details</LinkFormatting>"
        description={{
          text: "Opening Order Incentives Banner",
          img: "https://cdn.faire.com/fastly/958d7e99f48e8779f5fb3bc97c56a1e223ff1e38b9f82e185368344bdcb0cb44.png",
        }}
        values={{
          MediumFormatting: chunkTransformations.Medium,
          discountPercentageNumber: discountPercentage,
          LinkFormatting: LearnMoreLink,
          endDate,
        }}
      />
    </Typography>
  );
};

export const OpeningOrderIncentivesBanner = observer(
  OpeningOrderIncentivesBannerBase
);

const LearnMoreLink = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={getCurrentPath().append({ openingOrderIncentives: "1" }).toString()}
    data-test-id="opening-order-incentives-banner-link"
    onClick={trackPricingOpeningOrderIncentivesClickOfferBannerRedirectCtaClick}
  >
    {chunks}
  </Button>
);
